const SUBSTITUTION_TYPES = {
  LINK: 'link',
};

export default SUBSTITUTION_TYPES;
